<script lang="ts">
import { TriangleAlert } from '@lucide/svelte';
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialog as AlertDialogRoot,
  AlertDialogTitle,
} from '$lib/components/ui/alert-dialog/index.js';
import { confirmStore } from '../../stores/confirm.svelte';

const s = $derived(confirmStore.state);
</script>

<!--
  Controlled dialog. NOTE: bits-ui v2 AlertDialog.Action has NO auto-close wiring
  (unlike Cancel/Close), so we resolve() directly on click and close via the
  controlled `open` prop (resolve sets state.open=false). onOpenChange only handles
  the non-confirm dismiss paths (Cancel/Escape). Overlay-click is intentionally
  ignored — standard AlertDialog semantics (destructive confirms require explicit
  dismissal).
-->
<AlertDialogRoot
  open={s.open}
  onOpenChange={(open) => {
    if (!open) confirmStore.resolve(false);
  }}
>
  <AlertDialogContent>
    <AlertDialogHeader>
      <AlertDialogMedia class="bg-destructive/10 rounded-full">
        <TriangleAlert class="text-destructive" />
      </AlertDialogMedia>
      <AlertDialogTitle>{s.title}</AlertDialogTitle>
    </AlertDialogHeader>
    {#if s.name}
      <p
        class="text-foreground text-sm font-semibold text-center sm:group-data-[size=default]/alert-dialog-content:text-left"
      >
        {s.name}
      </p>
    {/if}
    {#if s.detail}
      <AlertDialogDescription>{s.detail}</AlertDialogDescription>
    {/if}
    <AlertDialogFooter>
      <AlertDialogCancel>{s.cancelText}</AlertDialogCancel>
      <AlertDialogAction
        variant="destructive"
        class="bg-destructive text-white hover:bg-destructive/90 border-transparent"
        onclick={() => confirmStore.resolve(true)}
      >
        {s.confirmText}
      </AlertDialogAction>
    </AlertDialogFooter>
  </AlertDialogContent>
</AlertDialogRoot>
